export function getRoute(): string {
  return window.location.pathname.split('/')[1]
}
